// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BaseRuleModalController from "./base_rule_modal_controller"
application.register("base-rule-modal", BaseRuleModalController)

import GameController from "./game_controller"
application.register("game", GameController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)
